import HomeScorecardCard from "./homeScorecardCard";
import PopUpScorecardFormCollaborate from "../../../../popUpForms/popUpScorecardFormCollaborate";

const CardScorecardPreparationMatters = ({
  hoveredTab,
  onTabHover,
  onTabLeave,
}) => {
  return (
    <HomeScorecardCard
      hoveredTab={hoveredTab}
      onTabHover={onTabHover}
      onTabLeave={onTabLeave}
      id="scorecard-preparation"
      title="Preparation Matters"
      titleColor="var(--orange)"
      image="./images/home/card-preparation-matters.png"
      popUpComponent={<PopUpScorecardFormCollaborate />}
      content={[
        {
          type: "header-H5",
          color: "var(--green)",
          text: "Protect your Community from Wildfires",
        },

        {
          type: "paragraph",
          color: "var(--gold)",
          text: "Catastrophic wildfires are impacting more and more communities across the globe affecting lives, homes, water, air, land and wildlife.",
        },
        {
          type: "paragraph",
          color: "var(--white)",
          text: "Use the Wildfire Scorecard to assess your wildfire risk, boost preparedness, and take steps to prevent wildfires in your community.",
        },
        { type: "button", color: "var(--orange)", text: "Pilot with Us" },
      ]}
    />
  );
};

export default CardScorecardPreparationMatters;
